export default {
  SituationCenter: '态势中心',
  FullScreenDisplay: '全屏展示',
  ExitFullScreen: '退出全屏',
  InternetStatisticsOfEndUsers: '终端用户上网统计',
  GatewayDisasterToleranceAnalysis: '网关状态统计',
  ServiceHealthAnalysis24Hours: '近12h服务健康分析',
  AlarmEventMonitoring24H: '近12h告警事件监控',
  BranchTrafficUsageTop5: '近12h分支峰值带宽使用率（top5）',
  BandwidthUsageStatistics24H: '近12h出口带宽使用统计',
  UpstreamAndDownlinkBandwidthTrends24H: '近12h上下行带宽趋势图',
  KeyQualityIndicators24H: '近12h关键质量指标',
  EndUsersNumber: '终端用户数',
  Piece: '件',
  AlarmEvent24Hours: '近12h告警事件',
  BandwidthUtilization24Hours: '近12h最大带宽使用率',
  GatewayInService: '服务中的网关',
  OpenDeviceGateway: '开启设备级容灾网关',
  OpenLinkGateway: '开启链路级容灾网关',
  AllGatewayServiceExceptionEvents: '网关服务异常事件',
  AllGatewayLinkExceptionEvents: '网关链路中断事件',
  DisasterRecoveryGatewayServiceExceptionEvent: '容灾网关服务异常事件',
  DisasterRecoveryGatewayLinkExceptionEvent: '容灾网关链路中断事件',
  AverageTimeOfEquipmentDisasterRecovery: '设备容灾平均用时（s）',
  AverageTimeOfLinkDisasterRecovery: '链路容灾平均用时（s）',
  Wired: '有线',
  BandWidthAvg: '平均业务使用带宽',
  MonitorDesc: '监控概述',
  ExcellentTip: '近12h内未发生关键异常事件',
  GoodTip: '近12h内发生关键异常事件且已恢复',
  ErrorTip: '近12h内发生关键异常事件且未恢复',
  HeadBranch: '总部',
  Branch: '分支',
  ServiceExceptionGateway: '服务异常的网关',
  Use: '使用',
  Purchase: '购买',
  UplinkBandwidth: '上行带宽',
  DownstreamBandwidth: '下行带宽',
  Top5branchalarmsinrecent24h: '近12h分支告警数TOP5',
}